import React, { useState } from "react";
import "../assets/css/form.css";
import { AlertTriangle, Check } from "lucide-react";

const Form = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    course: "",
    email: "",
    phone: "",
    terms: false,
  });

  const [message, setMessage] = useState({
    isSuccess: false,
    text: "",
  });
  const [displayBox, setDisplayBox] = useState(false);
  // api url and options
  const url = "https://nexatrux.com/backend/public/api/enroll";
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  };

  const [copySuccess, setCopySuccess] = useState(false);

  const handleOnchange = (event) => {
    const { type, name, value, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Simple validation
    if (
      !formData.fullName ||
      !formData.course ||
      !formData.email ||
      !formData.phone ||
      !formData.terms
    ) {
      setMessage({ isSuccess: false, text: "Please fill all the fields." });
      setDisplayBox(true);
      setTimeout(() => {
        setDisplayBox(false);
      }, 4000);
      return;
    }

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      console.log(data);
      if (response.ok) {
        setMessage({
          isSuccess: true,
          text: data.message || "Enrollment was successful",
        });
        setDisplayBox(true);
        setTimeout(() => {
          setDisplayBox(false);
        }, 4000);
      } else {
        setMessage({
          isSuccess: false,
          text:
            data.errors[0] ||
            "Something went wrong or Email has already been taken",
        });
        setDisplayBox(true);
        setTimeout(() => {
          setDisplayBox(false);
        }, 4000);
      }
    } catch (error) {
      console.error(error);
      setMessage({
        isSuccess: false,
        text: `${error} Network issue try again`,
      });
      setDisplayBox(true);
      setTimeout(() => {
        setDisplayBox(false);
      }, 4000);
    } finally {
      // Clear the form data
      setFormData({
        fullName: "",
        course: "",
        email: "",
        phone: "",
        terms: false,
      });
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText("6105121692");
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  return (
    <div className="form-container">
      <h3 className="title">Fill Your Data</h3>
      <div className="form-content">
        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleOnchange}
              required
            />
            <label
              htmlFor="fullName"
              className={formData.fullName ? "floating-label" : ""}
            >
              *Full Name
            </label>
          </div>

          <div className="input-container">
            <input
              type="text"
              id="course"
              name="course"
              value={formData.course}
              onChange={handleOnchange}
              required
            />
            <label
              htmlFor="course"
              className={formData.course ? "floating-label" : ""}
            >
              *Course
            </label>
          </div>

          <div className="input-container">
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleOnchange}
              required
            />
            <label
              htmlFor="email"
              className={formData.email ? "floating-label" : ""}
            >
              *Email
            </label>
          </div>

          <div className="input-container">
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleOnchange}
              required
            />
            <label
              htmlFor="phone"
              className={formData.phone ? "floating-label" : ""}
            >
              *WhatsApp No
            </label>
          </div>

          <div className="bank-detail">
            <p className="sub-header">How to make payment</p>
            <h4>
              Please make payment to the account below indicating your enrolled
              course in your description/narration
            </h4>
            <p>
              Bank Account: <span>6105121692</span>
              <button
                type="button"
                className="copy-btn"
                onClick={copyToClipboard}
              >
                {copySuccess ? "Copied!" : "Copy"}
              </button>
            </p>
            <p>
              Bank Name: <span>OPay</span>
            </p>
            <p>
              Account Name: <span>NEXA TRUX DIGITAL TECHNOLOGY</span>
            </p>
          </div>

          <div className="help">
            <div className="instructor">
              <p className="sub-header">For Web Development or UI/UX design</p>
              <p>
                Send payment proof via WhatsApp:
                <a
                  href="https://wa.me/2348105182900"
                  target="_blank"
                  rel="noreferrer"
                >
                  +2348105182900 or 08154444342
                </a>
              </p>
            </div>
            <div className="instructor">
              <p className="sub-header">For Data Science or Data Analysis</p>
              <p>
                Send payment proof via WhatsApp:
                <a
                  href="https://wa.link/oxt2xl"
                  target="_blank"
                  rel="noreferrer"
                >
                  +234 703 133 7482 or 08154444342
                </a>
              </p>
            </div>
          </div>

          <label className="check gap">
            <input
              type="checkbox"
              name="terms"
              checked={formData.terms}
              onChange={handleOnchange}
              required
            />
            <span>I agree to the privacy policy terms</span>
          </label>

          <button className="btn bg-btn">Submit</button>
        </form>
      </div>
      {displayBox && (
        <div className="form-popup">
          <div className="form-popup-content">
            <span>
              {message.isSuccess ? (
                <Check color="green" size={24} />
              ) : (
                <AlertTriangle color="red" size={24} />
              )}
            </span>
            <p>{message.text}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Form;
